import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import AddNewFabricDropdown from '@components/materials/AddNewFabricDropdown';

import { getCommonFilters } from '@store/reducers';

import { handleGetFabricCategoryList } from '@services/materialService';

import ApiClient from '@lib/apiClient';

import { getFabricTypeName, onGetFabricTypeList } from '@utils/MaterialsUtil';
import { printApiError } from '@utils/Util';

const AddNewFabricType = ({
	setIsAddNew,
	addNewValue,
	fabricTypeList,
	setNewFabricType,
	setIsLoading,
	selectedFabricTypeToEdit,
	setSelectedFabricTypeToEdit,
	setFabricTypeList
}) => {
	const [selectedFabricType, setSelectedFabricType] = useState(null);
	const [selectedSubCategoryType, setSelectedSubCategoryType] = useState(null);
	const [weave, setWeave] = useState(addNewValue);
	const [fabricErrors, setFabricErrors] = useState({});
	const [fabricSubCategoryList, setFabricSubCategoryList] = useState([]);
	const commonfilters = useSelector(getCommonFilters);

	const getSubCategoryList = async () => {
		const response = await handleGetFabricCategoryList(selectedFabricType);
		setFabricSubCategoryList(response);
	};

	useEffect(() => {
		if (selectedFabricTypeToEdit) {
			setSelectedFabricType(selectedFabricTypeToEdit?.fabricType);
			setSelectedSubCategoryType(selectedFabricTypeToEdit);
		}
	}, [selectedFabricTypeToEdit]);

	const isValidNewFabricAdd = () => {
		if (!selectedFabricType) {
			setFabricErrors((prevState) => ({ ...prevState, categoryError: 'Category is required' }));
			return false;
		} else {
			setFabricErrors((prevState) => ({ ...prevState, categoryError: undefined }));
		}
		if (weave.trim().length === 0) {
			setFabricErrors((prevState) => ({ ...prevState, weaveError: 'Fabric type/Weave is required' }));
			return false;
		} else {
			setFabricErrors((prevState) => ({ ...prevState, weaveError: undefined }));
		}
		return true;
	};

	const getSubCategory = (item) => {
		return item?.groupName || item?.name;
	};

	const onSubmit = async () => {
		try {
			const isValid = isValidNewFabricAdd();
			if (!isValid) return;
			const body = {
				name: weave,
				groupId: selectedFabricTypeToEdit
					? selectedFabricTypeToEdit?.groupId
					: selectedSubCategoryType?.id,
				fabricType: selectedFabricType
			};

			setIsLoading(true);
			let response;
			if (selectedFabricTypeToEdit) {
				response = await ApiClient.PUT('editFabricSubCategory', body, selectedFabricTypeToEdit?.id);
				const fabricList = await onGetFabricTypeList(commonfilters);
				setFabricTypeList(fabricList);
			} else {
				response = await ApiClient.POST('addFabricSubCategory', body);
			}
			if (response?.status === 200) {
				setNewFabricType(response);
				setFabricErrors({});
				setIsAddNew(false);
				setIsLoading(false);
				// if (setSelectedFabricTypeToEdit) {
				// 	setSelectedFabricTypeToEdit(null);
				// }
			}
		} catch (error) {
			setIsLoading(false);
			printApiError(error);
		}
	};
	return (
		<div className="add-fabric-type-dropdown p-3 bg-white shadow-24dp">
			<div className="row">
				<div className="col-md-6">
					<AddNewFabricDropdown
						label="Category*"
						title="Category"
						setSelectedFabricType={setSelectedFabricType}
						items={fabricTypeList}
						getFabricTypeName={getFabricTypeName}
						fabricErrors={fabricErrors.categoryError}
						selectedFabricType={selectedFabricType}
						onFetchSubCategory={getSubCategoryList}
					/>
				</div>

				<div className="col-md-6">
					<AddNewFabricDropdown
						label="Sub category*"
						title="Sub category"
						setSelectedFabricType={setSelectedSubCategoryType}
						items={fabricSubCategoryList}
						getFabricTypeName={getSubCategory}
						fabricErrors={fabricErrors.categoryError}
						selectedFabricType={selectedSubCategoryType}
						isSubCategory
						isDisabled={!selectedFabricType}
					/>
				</div>

				<div className="col-md-12 ml-1">
					<label htmlFor="weave">Fabric type/Weave*</label>
					<input
						id="weave"
						type="text"
						autoComplete="off"
						value={weave}
						onChange={(e) => setWeave(e.target.value)}
					/>
					{fabricErrors.weaveError && <p className="error">{fabricErrors.weaveError}</p>}
				</div>
			</div>
			<div className="d-flex justify-content-end pt-2">
				<button
					className="button text-only text-uppercase"
					onClick={() => {
						setIsAddNew(false);
						setSelectedFabricTypeToEdit(null);
					}}
				>
					Cancel
				</button>
				<button className="button text-only text-uppercase" onClick={onSubmit}>
					Submit
				</button>
			</div>
		</div>
	);
};
export default AddNewFabricType;
